import * as actions from './activity.actions'

const initialState = {
  data: [],
  otherPlayersData: [],
  visitingPlayer: [],
}

const actionsMap = {
  [actions.SET_ACTIVITY_DATA]: (state, action) => {
    return {
      ...state,
      data: action.data,
    }
  },
  [actions.SET_ACTIVITY_DATA_OTHER_PLAYERS]: (state, action) => {
    return {
      ...state,
      otherPlayersData: action.data,
    }
  },
  [actions.SET_ACTIVITY_BATTLES_VISITING_PLAYERS]: (state, action) => {
    return {
      ...state,
      visitingPlayer: action.data,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
